import React from 'react';
import {
  Box, Button, IconButton, TextField, Typography,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import FormSection from './FormSection';

const ItemsTable = ({ formData, handleItemChange, addItem, removeItem }) => {
  return (
    <FormSection>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">
          Articles
        </Typography>
        
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={addItem}
        >
          Ajouter un article
        </Button>
      </Box>
      
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Description</TableCell>
              <TableCell>Code produit</TableCell>
              <TableCell align="right">Quantité</TableCell>
              <TableCell>Unité</TableCell>
              <TableCell align="right">Prix unitaire</TableCell>
              <TableCell align="right">TVA (%)</TableCell>
              <TableCell align="right">Montant TVA</TableCell>
              <TableCell align="right">Total</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {formData?.items?.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TextField
                    value={item.description || ''}
                    onChange={(e) => handleItemChange(index, 'description', e.target.value)}
                    fullWidth
                    size="small"
                    variant="standard"
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    value={item.product_code || ''}
                    onChange={(e) => handleItemChange(index, 'product_code', e.target.value)}
                    size="small"
                    variant="standard"
                    sx={{ width: '100px' }}
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    value={item.quantity || ''}
                    onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                    type="number"
                    size="small"
                    variant="standard"
                    inputProps={{ min: 1, step: 1 }}
                    sx={{ width: '80px' }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    value={item.unit_of_measure || ''}
                    onChange={(e) => handleItemChange(index, 'unit_of_measure', e.target.value)}
                    size="small"
                    variant="standard"
                    sx={{ width: '60px' }}
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    value={item.unit_price || ''}
                    onChange={(e) => handleItemChange(index, 'unit_price', e.target.value)}
                    type="number"
                    size="small"
                    variant="standard"
                    inputProps={{ min: 0, step: 0.01 }}
                    sx={{ width: '100px' }}
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    value={item.tax_rate || ''}
                    onChange={(e) => handleItemChange(index, 'tax_rate', e.target.value)}
                    type="number"
                    size="small"
                    variant="standard"
                    inputProps={{ min: 0, step: 0.1 }}
                    sx={{ width: '60px' }}
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    value={item.tax_amount || ''}
                    onChange={(e) => handleItemChange(index, 'tax_amount', e.target.value)}
                    type="number"
                    size="small"
                    variant="standard"
                    inputProps={{ min: 0, step: 0.01 }}
                    sx={{ width: '80px' }}
                  />
                </TableCell>
                <TableCell align="right">
                  {item.total_price?.toFixed(2) || '0.00'} €
                </TableCell>
                <TableCell align="center">
                  <IconButton 
                    color="error" 
                    onClick={() => removeItem(index)}
                    size="small"
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {(!formData?.items || formData.items.length === 0) && (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography variant="body2" color="text.secondary">
                    Aucun article. Cliquez sur "Ajouter un article" pour commencer.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </FormSection>
  );
};

export default ItemsTable;